/********************************************* ASSETS *********************************************/
const s = require('../input-util-components.scss');

/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import cn from 'classnames';

/********************************************* EXPORT *********************************************/
export const TextArea = (props: React.HTMLProps<any>) => {
    const {className, ...passThroughProps} = props;
    const styles = cn(s['text-area'], className);
    return <textarea className={styles} {...passThroughProps} />;
};
